import { createAction } from "@reduxjs/toolkit";

export const historyPush = createAction("historyPush");
export const api = createAction("api");
export const hydrateState = createAction("hydrateState");
